import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import axiosInstance from '../api/axios';
import useAuthStore from '../store/useAuthStore';
import { motion } from 'framer-motion';
import { Mail, Lock, User, Briefcase, Rocket, Loader2 } from 'lucide-react';

const Register = () => {
    const { register, handleSubmit, formState: { errors } } = useForm();
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const { login } = useAuthStore();

    const onSubmit = async (data) => {
        setIsLoading(true);
        try {
            const response = await axiosInstance.post('/register', data);
            const { user, token } = response.data;
            
            // تسجيل الدخول فوراً بعد إنشاء الحساب
            login(user, token);
            toast.success('Account created! Your 14-day trial starts now 🎉');
            navigate('/dashboard'); // توجيه للوحة التحكم
            
        } catch (error) {
            toast.error(error.response?.data?.message || 'Registration failed. Try again.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '60px 20px' }}>
            <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="glass-card" style={{ width: '100%', maxWidth: '480px', padding: '40px', backgroundColor: 'white', borderRadius: '16px', boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1)' }}>
                
                <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                    <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '6px 12px', backgroundColor: '#ecfdf5', color: '#10b981', borderRadius: '20px', fontSize: '13px', fontWeight: '700', marginBottom: '15px' }}>
                        <Rocket size={16} /> Start 14-Day Free Trial
                    </div>
                    <h2 style={{ margin: 0, fontSize: '24px', fontWeight: '700', color: '#0f172a' }}>Create your account</h2>
                    <p style={{ margin: '8px 0 0 0', color: '#64748b', fontSize: '15px' }}>No credit card required to start.</p>
                </div>

                <form onSubmit={handleSubmit(onSubmit)} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                    
                    {/* Full Name & Workspace (Grid Layout for compact view) */}
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                        <div>
                            <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '600', color: '#334155' }}>Full Name</label>
                            <div style={{ position: 'relative' }}>
                                <div style={{ position: 'absolute', top: '50%', left: '12px', transform: 'translateY(-50%)', color: '#94a3b8' }}><User size={18} /></div>
                                <input type="text" placeholder="John Doe" {...register('name', { required: true })} style={{ width: '100%', padding: '12px 12px 12px 40px', border: '1px solid #e2e8f0', borderRadius: '8px', outline: 'none' }} />
                            </div>
                        </div>

                        <div>
                            <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '600', color: '#334155' }}>Workspace Name</label>
                            <div style={{ position: 'relative' }}>
                                <div style={{ position: 'absolute', top: '50%', left: '12px', transform: 'translateY(-50%)', color: '#94a3b8' }}><Briefcase size={18} /></div>
                                <input type="text" placeholder="Acme Inc." {...register('workspace_name', { required: true })} style={{ width: '100%', padding: '12px 12px 12px 40px', border: '1px solid #e2e8f0', borderRadius: '8px', outline: 'none' }} />
                            </div>
                        </div>
                    </div>

                    <div>
                        <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '600', color: '#334155' }}>Email Address</label>
                        <div style={{ position: 'relative' }}>
                            <div style={{ position: 'absolute', top: '50%', left: '12px', transform: 'translateY(-50%)', color: '#94a3b8' }}><Mail size={18} /></div>
                            <input type="email" placeholder="name@company.com" {...register('email', { required: true })} style={{ width: '100%', padding: '12px 12px 12px 40px', border: '1px solid #e2e8f0', borderRadius: '8px', outline: 'none' }} />
                        </div>
                    </div>

                    <div>
                        <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '600', color: '#334155' }}>Password</label>
                        <div style={{ position: 'relative' }}>
                            <div style={{ position: 'absolute', top: '50%', left: '12px', transform: 'translateY(-50%)', color: '#94a3b8' }}><Lock size={18} /></div>
                            <input type="password" placeholder="Min. 8 characters" {...register('password', { required: true, minLength: 8 })} style={{ width: '100%', padding: '12px 12px 12px 40px', border: '1px solid #e2e8f0', borderRadius: '8px', outline: 'none' }} />
                        </div>
                    </div>

                    <button type="submit" disabled={isLoading} className="action-btn" style={{ width: '100%', padding: '12px', backgroundColor: '#3b82f6', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', marginTop: '10px' }}>
                        {isLoading ? <><Loader2 size={18} className="animate-spin" /> Creating account...</> : <>Create Account</>}
                    </button>
                </form>

                <div style={{ textAlign: 'center', marginTop: '25px', fontSize: '14px', color: '#64748b' }}>
                    Already have an account? <Link to="/login" style={{ color: '#3b82f6', fontWeight: '600', textDecoration: 'none' }}>Sign In</Link>
                </div>
            </motion.div>
        </div>
    );
};

export default Register;